import React from "react";
import { useVenueService } from "~pages/Venues/hooks/useVenueService.ts";
import AddAndEditVenueModal from "./AddAndEditVenueModal";

const AddVenue = (props) => {
  const { isModalOpen, handleClose, onAdd } = props;
  const { createVenue, isCreatePending } = useVenueService();

  const handleSendRequest = async (form) => {
    try {
      const data = await form.validateFields();
      const createdVenue = await createVenue({
        ...data,
      });

      if (!createdVenue) {
        return;
      }

      onAdd?.(createdVenue);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <AddAndEditVenueModal
        {...props}
        openModal={isModalOpen}
        handleCloseModal={handleClose}
        handleSendRequest={handleSendRequest}
        okButtonLoading={isCreatePending}
      />
    </>
  );
};

export default AddVenue;
